import React, {useState} from 'react'
import PropTypes from 'prop-types'
import {formatInt} from '../../helpers/format'

/**
 * Danh sách mã SKU đi kèm một thông báo — thu về đúng một dòng, bấm mới mở hết.
 *
 * Cảnh báo "chưa gán quy trình sản xuất" có thể kèm tới 375 mã. Đổ hết ra thì khối thông báo cao
 * hơn cả màn hình, đẩy bộ lọc và bảng xuống dưới nếp gấp, và chính câu cảnh báo — thứ người dùng
 * cần đọc — bị chìm trong một bức tường mã.
 *
 * Số ở nút là số mã CÒN LẠI ngoài dòng đầu, không phải tổng. Tổng đã nằm ngay trong câu cảnh báo
 * ("375 SKU đang bật chưa gán…"), nhắc lại là thừa.
 */
/**
 * Chấp nhận cả chuỗi trần (danh sách SKU — bản thân chuỗi CHÍNH LÀ mã) lẫn `{label, code}` (danh
 * sách NVL — mã kèm tên người đọc được). Gộp hai dạng vào một component để hai vùng thông báo
 * không trôi ra hai kiểu hiển thị khác nhau.
 */
const normalize = (item) => (typeof item === 'string' ? {code: item, label: null} : item || {})

function SkuIdList({ids, previewCount, unit}) {
    const [expanded, setExpanded] = useState(false)
    const list = (ids || []).map(normalize).filter((item) => item.code || item.label)

    if (!list.length) return null

    const hiddenCount = list.length - previewCount

    return (
        <div className={`VcSkuIdList ${expanded ? 'VcSkuIdList--open' : ''}`}>
            <span className="VcSkuIdList__ids">
                {(expanded ? list : list.slice(0, previewCount)).map((item, index) => (
                    <span className="VcSkuIdList__chip" key={`${item.code || item.label}-${index}`}>
                        {item.code && <span className="VcSkuIdList__chipCode">{item.code}</span>}
                        {item.label && item.label !== item.code && (
                            <span className="VcSkuIdList__chipLabel" title={item.label}>
                                {item.label}
                            </span>
                        )}
                    </span>
                ))}
            </span>

            {hiddenCount > 0 && (
                <button
                    type="button"
                    className="VcSkuIdList__toggle"
                    onClick={() => setExpanded(!expanded)}
                >
                    {expanded ? 'Thu gọn' : `+${formatInt(hiddenCount)} ${unit}`}
                </button>
            )}
        </div>
    )
}

SkuIdList.propTypes = {
    ids: PropTypes.arrayOf(
        PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.shape({label: PropTypes.string, code: PropTypes.string}),
        ])
    ),
    /** Số chip hiện ở dòng thu gọn. Ít thôi — tên NVL dài, quá 5 là tràn dòng trên màn hẹp. */
    previewCount: PropTypes.number,
    /** Đơn vị đếm trên nút, ví dụ `+370 SKU` hay `+125 NVL`. */
    unit: PropTypes.string,
}

SkuIdList.defaultProps = {
    ids: [],
    previewCount: 5,
    unit: 'SKU',
}

export default SkuIdList
